import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from 'material-ui/styles';
import ExpansionPanel, {
  ExpansionPanelDetails,
  ExpansionPanelSummary
} from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';

const styles = () => ({
  root: {},
  summary: {
    alignItems: 'center',
  },
})

export const MaterialPanel = ({
  classes,
  expanded,
  onToggle,
  summary,
  detail
}) => (
  <ExpansionPanel
    className={classes.root}
    expanded={expanded}
    onChange={onToggle}
  >
    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
      {summary}
    </ExpansionPanelSummary>
    <ExpansionPanelDetails>
      {detail}
    </ExpansionPanelDetails>
  </ExpansionPanel>
);

MaterialPanel.propTypes = {
  classes:  PropTypes.shape({
    root: PropTypes.string,
    summary: PropTypes.string
  }).isRequired,
  expanded:  PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  summary:  PropTypes.element.isRequired,
  detail:   PropTypes.element.isRequired,
}

export default withStyles(styles)(MaterialPanel);



// WEBPACK FOOTER //
// ./src/components/common/MaterialPanel/Panel.js